import ImportRecordsModal from "@/components/ImportRecordsModal";

// Fields the importer can map to. `company` is required.
const FIELDS = [
  { key: "sourced_from", label: "Sourced From" },
  { key: "_blank", label: "—" },
  { key: "company", label: "Company", required: true },
  { key: "contact", label: "Contact Person" },
  { key: "country", label: "Country" },
  { key: "city_or_state", label: "City / State" },
  { key: "dealing_in", label: "Dealing In" },
  { key: "quality", label: "Quality" },
  { key: "phones", label: "Phones (; or , separated)" },
  { key: "emails", label: "Emails (; or , separated)" },
  { key: "address", label: "Address" },
  { key: "website", label: "Website" },
  { key: "supplier_since", label: "Supplier Since (YYYY-MM-DD)" },
  { key: "rating", label: "Rating (0–5)" },
  { key: "notes", label: "Notes" },
  { key: "sales_person_name", label: "Sales Person (name)" },
  { key: "sales_person_email", label: "Sales Person (email — links to user)" },
];

export default function ImportSuppliersModal({ onClose, onImported }) {
  return (
    <ImportRecordsModal
      onClose={onClose}
      onImported={onImported}
      title="Import Suppliers"
      subtitle="Upload a CSV and map columns to fields"
      endpoint="/suppliers/import"
      fields={FIELDS}
      entitySingular="supplier"
      entityPlural="suppliers"
      failedFileName="failed_suppliers.csv"
    />
  );
}
